// src/services/ticketService.js

import axiosHandler from "../../Intersepter/axiosInstance";

// Get lucky tickets by user ID and ticket number
export const getLuckyTicketsByUserAndTicketNo = async (userId, ticketNo) => {
  console.log("ticketNo", ticketNo);
  try {
    const response = await axiosHandler.get(
      `/ticket-purchase/lottery?user_id=${userId}&ticket_number=${ticketNo}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching lucky tickets by user ID and ticket number:",
      error
    );
    throw error; // Re-throw the error for further handling if needed
  }
};

// Get lucky tickets by date range and ticket number
export const getLuckyTicketsByDateAndTicketNo = async (
  startDate,
  endDate,
  ticketNo
) => {
  try {
    const response = await axiosHandler.get(
      `/ticket-purchase/lottery?start_date=${startDate}&end_date=${endDate}&ticket_number=${ticketNo}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching lucky tickets by date range and ticket number:",
      error
    );
    throw error;
  }
};

// Get lucky tickets by date range and ticket number
export const getLuckyTicketsByDate = async (startDate, endDate) => {
  try {
    const response = await axiosHandler.get(
      `/ticket-purchase/lottery?start_date=${startDate}&end_date=${endDate}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lucky tickets by date range ", error);
    throw error;
  }
};

// Get all lucky tickets
export const getAllLuckyTickets = async () => {
  try {
    const response = await axiosHandler.get("/ticket-purchase/lottery");
    console.log("Lucky tickets response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching all lucky tickets:", error);
    throw error;
  }
};
